import React from 'react';
import PropTypes from 'prop-types';
export const GenAiIcon = ({
  width = '24',
  height = '24',
  color = '#444445',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.6144 5.20538C9.277 4.43278 8.20776 4.43278 7.8704 5.20538L6.99275 7.21558C6.21171 9.00438 4.80589 10.4284 3.0523 11.2068L0.63658 12.2791C-0.131464 12.62 -0.131463 13.7373 0.63658 14.0782L2.97685 15.117C4.77553 15.9155 6.20657 17.3922 6.97427 19.2421L7.8633 21.3842C8.19319 22.1792 9.2916 22.1792 9.6215 21.3842L10.5105 19.242C11.2782 17.3922 12.7092 15.9155 14.5079 15.117L16.8482 14.0782C17.6162 13.7373 17.6162 12.62 16.8482 12.2791L14.4325 11.2068C12.6789 10.4284 11.2731 9.00438 10.492 7.21558L9.6144 5.20538ZM3.53956 13.1786C5.8254 12.164 7.68402 10.4962 8.74238 8.20138C9.8008 10.4962 11.6594 12.164 13.9452 13.1786C11.6321 14.2054 9.7676 15.9545 8.74239 18.2901C7.71719 15.9545 5.85267 14.2054 3.53956 13.1786ZM18.4014 0.311077L18.6482 0.876776C19.0882 1.88538 19.8807 2.68848 20.8695 3.12778L21.6299 3.46568C22.0412 3.64838 22.0412 4.24608 21.6299 4.42878L20.9121 4.74778C19.8978 5.19838 19.0911 6.03118 18.6586 7.07408L18.4052 7.68538C18.2285 8.11137 17.6395 8.11137 17.4628 7.68538L17.2094 7.07408C16.777 6.03118 15.9703 5.19838 14.956 4.74778L14.2381 4.42878C13.8269 4.24608 13.8269 3.64838 14.2381 3.46568L14.9985 3.12778C15.9874 2.68848 16.7798 1.88538 17.2198 0.876776L17.4667 0.311077C17.6473 -0.103024 18.2207 -0.103024 18.4014 0.311077ZM17.3745 3.95408L17.937 4.51268L18.4878 3.95408L17.937 3.41118L17.3745 3.95408Z"
      fill={color}
    />
  </svg>
);

GenAiIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string,
};
